export default class CreateTimesheetRowData {
  execute(source) {
    const resultArray = [];
    source.items.forEach((row) => {
      row.values.categoryId = source.categoryId;
      row.values.name = row.name;
      row.values.itemId = row.itemId;
      row.values.isHidden = this.hiddenItems.has(Number(row.itemId));
      resultArray.push(row.values);
    });
    return resultArray;
  }
}
